import React, { useState } from "react";
import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";
import { profile } from "../data/profile";

function Footer() {
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    await fetch(`https://formsubmit.co/ajax/${profile.contact.email}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        email,
        _subject: "New Newsletter Subscriber!",
      }),
    });

    setSubmitted(true);
    setEmail("");
  };

  return (
    <footer id="contact" className="contact site-footer text-white py-5 px-3">
      <div className="container site-section-inner">
        <header className="section-head section-head--on-dark">
          <p className="section-eyebrow">Contact</p>
          <h2 className="section-title">Let&apos;s build something</h2>
          <p className="section-lead">
            Open to software engineering roles and collaborations in backend, cloud, and AI.
          </p>
        </header>

        <div className="row align-items-start gy-4">
          <div className="col-md-6">
            {submitted ? (
              <h3 className="h5 text-white mb-0">Thank you for signing up!</h3>
            ) : (
              <>
                <h3 className="h5">Sign up for my newsletter</h3>
                <form onSubmit={handleSubmit} className="d-flex flex-column flex-sm-row gap-2">
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control flex-grow-1"
                    placeholder="Enter your email"
                  />
                  <button type="submit" className="btn btn-primary flex-shrink-0">
                    Subscribe
                  </button>
                </form>
              </>
            )}
          </div>

          <div className="col-md-6 text-md-end">
            <h3 className="h5">Let&apos;s collaborate</h3>
            <a
              href={profile.contact.calendly}
              className="btn btn-outline-light btn-sm mb-3"
              target="_blank"
              rel="noreferrer"
            >
              Book a Coffee Chat
            </a>
            <div className="site-footer-social d-flex gap-2 justify-content-md-end">
              <a href={`mailto:${profile.contact.email}`} aria-label="Email">
                <FaEnvelope />
              </a>
              <a
                href={profile.contact.linkedin}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href={profile.contact.github}
                target="_blank"
                rel="noreferrer"
                aria-label="GitHub"
              >
                <FaGithub />
              </a>
            </div>
          </div>
        </div>

        <hr className="border-secondary mt-4" />
        <p className="text-center small mb-0 opacity-75">
          © {new Date().getFullYear()} {profile.name} · All rights reserved
        </p>
      </div>
    </footer>
  );
}

export default Footer;
